function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* globals document */

import React from 'react';
import PropTypes from 'prop-types';
import Flyout from '../Flyout';
var TooltipHost = /*#__PURE__*/function (_React$Component) {
  _inherits(TooltipHost, _React$Component);
  var _super = _createSuper(TooltipHost);
  function TooltipHost() {
    var _this;
    _classCallCheck(this, TooltipHost);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      visible: false
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var parent = _this.props.parent;
      _this.parentNode = document.getElementById(parent);
      if (_this.parentNode) {
        _this.parentNode.addEventListener('mouseenter', _this.handleMouseEnter);
        _this.parentNode.addEventListener('mouseleave', _this.handleMouseLeave);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (_this.parentNode) {
        _this.parentNode.removeEventListener('mouseenter', _this.handleMouseEnter);
        _this.parentNode.removeEventListener('mouseleave', _this.handleMouseLeave);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function () {
      _this.setState({
        visible: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function (e) {
      var locked = _this.props.locked;
      var tooltipNode = document.getElementById('tooltip-root');
      var tooltipIsBeingHovered = false;
      try {
        // If the user moves the mouse from the host (event.target) to the tooltip
        // The tooltip should remain open
        tooltipIsBeingHovered = tooltipNode && tooltipNode.contains(e.relatedTarget);
      } catch (err) {
        tooltipIsBeingHovered = false;
      }
      if (!locked || locked && !tooltipIsBeingHovered) {
        _this.setState({
          visible: false
        });
      }
      return false;
    });
    return _this;
  }
  _createClass(TooltipHost, [{
    key: "render",
    value: function render() {
      var visible = this.state.visible;
      var _this$props = this.props,
        children = _this$props.children,
        animation = _this$props.animation,
        side = _this$props.side,
        parent = _this$props.parent,
        className = _this$props.className,
        fallbackRenderSide = _this$props.fallbackRenderSide,
        isStatic = _this$props.isStatic;
      return visible && /*#__PURE__*/React.createElement(Flyout, {
        type: "tooltip",
        parent: parent,
        side: side,
        animation: animation,
        fallbackRenderSide: fallbackRenderSide,
        onMouseLeave: this.handleMouseLeave,
        className: className,
        isStatic: isStatic
      }, children);
    }
  }]);
  return TooltipHost;
}(React.Component);
TooltipHost.defaultProps = {
  children: null,
  animation: 'fadeIn',
  side: 'top',
  locked: false,
  className: '',
  fallbackRenderSide: 'top',
  isStatic: false
};
TooltipHost.propTypes = {
  children: PropTypes.node,
  animation: PropTypes.oneOf(['fadeIn']),
  parent: PropTypes.node.isRequired,
  side: PropTypes.oneOf(['top', 'bottom', 'left', 'right', 'topRight', 'bottomRight', 'topLeft', 'bottomLeft']),
  locked: PropTypes.bool,
  isStatic: PropTypes.bool,
  className: PropTypes.string,
  fallbackRenderSide: PropTypes.oneOf(['top', 'bottom', 'left', 'right', 'topRight', 'bottomRight', 'topLeft', 'bottomLeft'])
};
TooltipHost.displayName = 'TooltipHost';
export default TooltipHost;